module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-full"
  }, [_c('h1', [_vm._v("Building Your Site Right the First Time")]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("Today, more than ever, success in business starts with online visibility. Your business needs to be easy to find on the web. We can help. Making you visible online is our business.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("A great deal of our work involves re-developing web sites that were created by web companies who didn't develop with an understanding of SEO. That's why choosing Visible to build your web site is a "), _c('em', [_vm._v("smart business decision")]), _vm._v(". Since 2008, Visible has developed hundreds of beautiful and functional web sites that adhere to "), _c('em', [_vm._v("SEO best practices")]), _vm._v(".")]), _vm._v(" "), _c('h1', [_vm._v("Core Capabilities")]), _vm._v(" "), _c('div', {
    staticClass: "columns core"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('img', {
    attrs: {
      "src": "static/development.jpg",
      "alt": "Full Stack Web Development"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Full Stack Web Development")]), _vm._v(" "), _c('p', [_vm._v("Visible provides top notch web development from front-end javascript, styling, and UI/UX to back-end development, CMS management, and database design.")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('img', {
    attrs: {
      "src": "static/seo.jpg",
      "alt": "Search Engine Optimization"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Search Engine Optimization (SEO)")]), _vm._v(" "), _c('p', [_vm._v("Visible provides the full gamut of SEO support.  Whether it be reviewing analytics, providing key phrase research, or performing technical audits, Visible has the experience to maximize your site's search engine traffic.")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('img', {
    attrs: {
      "src": "static/design.jpg",
      "alt": "Web Design"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Web Design")]), _vm._v(" "), _c('p', [_vm._v("Visible partners with industry leaders in web design to provide an exceptional experience to site visitors.  Our sites are designed to be responsive, with desktop, laptop, and mobile devices in mind.")])])])])]), _vm._v(" "), _c('h1', [_vm._v("Technologies")]), _vm._v(" "), _c('div', {
    staticClass: "columns technologies"
  }, [_c('div', {
    staticClass: "is-half column"
  }, [_c('h2', [_vm._v("Languages")]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/js.png",
      "alt": "JavaScript"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/php.png",
      "alt": "PHP"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/aspnet.png",
      "alt": "ASP.NET"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/html5.png",
      "alt": "HTML5"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/css3.png",
      "alt": "CSS3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/sass.png",
      "alt": "Sass"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/less.png",
      "alt": "less"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "is-half column"
  }, [_c('h2', [_vm._v("Frameworks / Libraries")]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/jquery.png",
      "alt": "jQuery"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/vue.png",
      "alt": "Vue"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/react.png",
      "alt": "React"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/angular.png",
      "alt": "Angular"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/foundation.png",
      "alt": "Foundation"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/bootstrap.png",
      "alt": "Bootstrap"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/bulma.png",
      "alt": "Bulma"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "columns technologies"
  }, [_c('div', {
    staticClass: "is-half column"
  }, [_c('h2', [_vm._v("Content Management Systems & Databases")]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/wp.png",
      "alt": "WordPress"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/drupal.png",
      "alt": "Drupal"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/magento.png",
      "alt": "Magento"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/mssql.png",
      "alt": "Microsoft SQL Server"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/mysql.png",
      "alt": "MySQL"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/mongodb.png",
      "alt": "MongoDB"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "is-half column"
  }, [_c('h2', [_vm._v("Software & Build Tools")]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/adobeps.png",
      "alt": "Adobe Photoshop"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/sublime.png",
      "alt": "Sublime Text"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/vscode.png",
      "alt": "Visual Studio Code"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/git.png",
      "alt": "Git"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/npm.png",
      "alt": "NPM"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/gulp.png",
      "alt": "Gulp"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/webpack.png",
      "alt": "Webpack"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tech"
  }, [_c('img', {
    attrs: {
      "src": "static/tech/babel.png",
      "alt": "Babel"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40ff7421!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 110
// module chunks = 2